





















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Index extends Vue {
  @Prop({ default: '개인정보 수집/이용동의' }) title: any
  @Prop() privacyData: any
  isChecked = false

  get onCheck() {
    return this.isChecked
  }

  set onCheck(value: any) {
    this.isChecked = value
    this.$emit('update', this.isChecked)
  }
}
